import CONSTANTS from '../constants'

const validateEmail = (email) => {
  // checks via regex for proper email components
  let validString = CONSTANTS.EMAIL_REGEX.test(String(email).toLowerCase())
  return validString
}

export default validateEmail
